export default "__VITE_ASSET__D6Oh4HIA__"